import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const SocialSecurityUnitedStates = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { socialSecurityNo, errors } = formState;

  const inputElements = [
    {
      belongsTo: ['United States Residential'],
      element: (
        <TextFieldGroup
          key="socialSecurityNo"
          id="socialSecurityNo"
          type="text"
          name="socialSecurityNo"
          dataName="socialSecurityNoUS"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.socialSecurityNo')}
          value={socialSecurityNo}
          placeholder={transUTL(
            'translatePlaceholder.inputUS.socialSecurityNo'
          )}
          placeholderTrigger={isEmptyVAL(socialSecurityNo) ? 'input-empty' : ''}
          error={errors.socialSecurityNo}
          errorTrigger={errors.socialSecurityNo ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

SocialSecurityUnitedStates.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default SocialSecurityUnitedStates;
